/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { SavedFilterDTOFromJSON, SavedFilterDTOToJSON, } from '../models/index';
/**
 *
 */
export class SavedFilterControllerApi extends runtime.BaseAPI {
    /**
     */
    async createSavedFilterRaw(requestParameters, initOverrides) {
        if (requestParameters['savedFilterDTO'] == null) {
            throw new runtime.RequiredError('savedFilterDTO', 'Required parameter "savedFilterDTO" was null or undefined when calling createSavedFilter().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/saved-filters`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SavedFilterDTOToJSON(requestParameters['savedFilterDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => SavedFilterDTOFromJSON(jsonValue));
    }
    /**
     */
    async createSavedFilter(requestParameters, initOverrides) {
        const response = await this.createSavedFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteSavedFilterRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteSavedFilter().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/saved-filters/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteSavedFilter(requestParameters, initOverrides) {
        await this.deleteSavedFilterRaw(requestParameters, initOverrides);
    }
    /**
     */
    async getAllSavedFiltersRaw(requestParameters, initOverrides) {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError('type', 'Required parameter "type" was null or undefined when calling getAllSavedFilters().');
        }
        const queryParameters = {};
        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/saved-filters`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SavedFilterDTOFromJSON));
    }
    /**
     */
    async getAllSavedFilters(requestParameters, initOverrides) {
        const response = await this.getAllSavedFiltersRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const GetAllSavedFiltersTypeEnum = {
    Keyword: 'KEYWORD',
    Store: 'STORE',
    Search: 'SEARCH',
    ProductStaging: 'PRODUCT_STAGING',
    Inventory: 'INVENTORY'
};
